export default __webpack_public_path__ + "static/media/employee_list_example.0c22155e.csv";